import { useState, useEffect } from 'react';

export const usePushSubscription = () => {
    const [isSubscribed, setIsSubscribed] = useState<boolean | null>(null);

    useEffect(() => {
        const checkSubscription = async () => {
            if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
                setIsSubscribed(false);
                return;
            }

            try {
                const registration = await navigator.serviceWorker.ready;
                const subscription = await registration.pushManager.getSubscription();
                setIsSubscribed(!!subscription);
            } catch (error) {
                console.error('Error checking push subscription:', error);
                setIsSubscribed(false);
            }
        };

        checkSubscription();
    }, []);

    return { isSubscribed };
};
